import { FiChevronRight, FiCheckCircle } from "react-icons/fi";
import { 
  HiOutlineExclamationCircle,
  HiOutlineDocumentText,
  HiOutlineCube,
  HiOutlineBadgeCheck
} from "react-icons/hi";

export function renderintegration () {
    return (
  <div className="transition-opacity duration-300">

    {/* Breadcrumb */}
    <nav className="flex items-center gap-2 text-xs font-medium text-gray-400 mb-8">
      <a className="hover:text-primary transition-colors" href="#">Netraa APM</a>
      <FiChevronRight className="text-sm" />
      <span className="text-gray-900 dark:text-gray-200">Integrations</span>
    </nav>

    {/* Heading */}
    <section className="mb-12 scroll-mt-24" id="integrations-overview">
      <h1 className="text-4xl lg:text-5xl font-extrabold leading-tight mb-6">
         <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
          Netraa APM Integrations:
        </span><br />
        Building an Integrated Ecosystem
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
        Modern observability does not exist in isolation. Netraa APM connects your telemetry data with the tools your team uses every day, from CI/CD pipelines to incident management. Our goal is to make observability data actionable where you already work.
      </p>
    </section>


{/* ITSM Section */}
<section className="mb-16 scroll-mt-24" id="jira-integration">

  <div className="flex items-center gap-3 mb-6">
    <HiOutlineExclamationCircle className="text-primary text-3xl" />
    <h2 className="text-2xl font-bold">ITSM & Incident Management (Jira)</h2>
  </div>

  <p className="text-gray-600 dark:text-gray-400 mb-10">
    Netraa's integration with Jira Service Management allows for bidirectional sync.
  </p>

  {/* Diagram */}
  <div className="
    bg-gray-50 dark:bg-gray-800/50 
    rounded-xl p-6 md:p-8 
    border border-gray-200 dark:border-gray-700
    flex flex-col md:flex-row 
    items-center justify-center 
    gap-6 md:gap-10
    relative
  ">

    {/* Netraa Alert */}
    <div className="flex flex-col items-center gap-3 text-center">
      <div className="w-16 h-16 rounded-xl bg-red-500/10 flex items-center justify-center text-red-600">
        <HiOutlineExclamationCircle className="text-3xl" />
      </div>
      <span className="text-xs font-bold uppercase text-gray-500">
        Netraa Alert
      </span>
    </div>

    {/* Connector */}
    <div className="
      w-0.5 h-10 md:h-px md:w-24 
      bg-gradient-to-b md:bg-gradient-to-r 
      from-red-500 via-primary to-blue-500
    " />

    {/* Jira Ticket */}
    <div className="flex flex-col items-center gap-3 text-center">
      <div className="w-16 h-16 rounded-xl bg-blue-500 flex items-center justify-center text-white">
        <HiOutlineDocumentText className="text-3xl" />
      </div>
      <span className="text-xs font-bold uppercase text-gray-500">
        Jira Ticket
      </span>
    </div>

  </div>
</section>
{/* Ecosystem */}
<section className="mb-16 scroll-mt-24" id="integration-ecosystem">
  <div className="flex items-center gap-3 mb-6">
    <HiOutlineCube className="text-primary text-3xl" />
    <h2 className="text-2xl font-bold">Supported Integration Ecosystem</h2>
  </div>

  <div className="grid grid-cols-2 sm:grid-cols-2 gap-6">
    {[
      { name: "Jira Software", desc: "ITSM & Workflows", logo: "/logos/jira.jpeg" },
      { name: "ServiceNow", desc: "Enterprise ITSM", logo: "/logos/servicenow.png" },
      { name: "GitLab", desc: "Pipeline Observability", logo: "/logos/gitlab.png" },
      { name: "Jenkins", desc: "CI/CD Gateways", logo: "/logos/jenkins.png" },
    ].map((item, i) => (
      <div
        key={i}
        className="p-6 bg-white dark:bg-gray-800 rounded-xl border shadow-sm hover:shadow-md hover:border-primary/30 transition-all flex flex-col items-center text-center group"
      >
        <div className="size-14 mb-4 group-hover:scale-110 transition-transform flex items-center justify-center rounded-lg text-primary">
          <img
            src={item.logo}
            alt={item.name}
            className="w-8 h-8 object-contain"
          />
        </div>
        <h4 className="font-bold text-sm">{item.name}</h4>
        <p className="text-xs text-gray-500 mt-2">{item.desc}</p>
      </div>
    ))}
  </div>
</section>


    {/* Strategy */}
    <section className="mb-16 scroll-mt-24" id="integration-strategy">
      <div className="flex items-center gap-3 mb-6">
        <HiOutlineBadgeCheck className="text-primary text-3xl" />
        <h2 className="text-2xl font-bold">Integration Strategy & Benefits</h2>
      </div>

      <ul className="space-y-4 text-gray-600 dark:text-gray-400">
        {[
          "Reduced MTTR: Automatic enrichment of tickets means engineers do not waste time searching logs.",
          "Cross-Team Visibility: Management gets Jira views while engineers receive deep-technical insights in real-time.",
          "Automation Ready: Every integration is backed by Discriptive graphs and various APIs enabling custom workflows."
        ].map((text,i)=>(
          <li key={i} className="flex gap-4 items-start">
            <FiCheckCircle className="text-primary mt-1" />
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </section>

  </div>
);
}